/* useSmartRec.js, hook that resolves the right SmartStrip props for
   the current page + user. Centralises the resolver call + auth read
   so every display surface (FAB, rail, toast, banner, exit-intent,
   mid-article, footer) stays in sync.
*/
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSmartRecommendation, isPathExcluded } from './smartRecommendationResolver';
import { useAuth } from '../../workspace/context/AuthContext';

// Session-scoped "I already have finance sorted" flag. When set, the
// resolver routes finance-targeted users to inspection support instead
// of pushing finance again.
const FINANCE_SORTED_KEY = 'bp-finance-sorted';
export function isFinanceSorted() {
  try { return sessionStorage.getItem(FINANCE_SORTED_KEY) === '1'; } catch { return false; }
}
export function markFinanceSorted() {
  try { sessionStorage.setItem(FINANCE_SORTED_KEY, '1'); } catch { /* ignore */ }
  try { window.dispatchEvent(new Event('bp-finance-sorted-changed')); } catch { /* ignore */ }
}

export default function useSmartRec(surface = 'inline', mode = 'content') {
  const { pathname, search } = useLocation();
  const [financeSuppressed, setFinanceSuppressed] = useState(() => isFinanceSorted());
  useEffect(() => {
    const onChange = () => setFinanceSuppressed(isFinanceSorted());
    window.addEventListener('bp-finance-sorted-changed', onChange);
    return () => window.removeEventListener('bp-finance-sorted-changed', onChange);
  }, []);
  let user = null;
  let profile = null;
  try {
    const auth = useAuth();
    user = auth?.user || null;
    profile = auth?.profile || null;
  } catch (e) { /* logged-out branch */ }
  if (isPathExcluded(pathname)) return { rec: null, pathname, isLoggedIn: !!user };
  const rec = resolveSmartRecommendation({
    pathname,
    search,
    surface,
    mode,
    profile,
    isLoggedIn: !!user,
    financeSuppressed,
  });
  return { rec, pathname, isLoggedIn: !!user };
}
